/**
 * 子域时间戳：t{数字} 验证门，n{数字} 导航落地（仅前缀，不支持 ?t=）。
 * 10 位按秒，13 位按毫秒；默认 60s 有效。
 */
export function parseSubdomainTimestamp(hostname, prefix) {
  if (!hostname || typeof hostname !== "string" || !prefix) return null;
  const first = hostname.split(".")[0];
  const m = new RegExp(`^${prefix}(\\d+)$`, "i").exec(first);
  if (!m) return null;
  const digits = m[1];
  const n = Number(digits);
  if (!Number.isFinite(n) || n < 0) return null;
  const tsMs = digits.length >= 13 ? n : n * 1000;
  return { tsMs, tsSec: digits.length >= 13 ? Math.floor(n / 1000) : n, prefix };
}

export function parseGateTimestamp(hostname) {
  return parseSubdomainTimestamp(hostname, "t");
}

export function parseNavTimestamp(hostname) {
  return parseSubdomainTimestamp(hostname, "n");
}

export function isSubdomainLinkExpired(tsMs, ttlMs = 60_000) {
  return Date.now() - tsMs > ttlMs;
}

export function isGateLinkExpired(hostname, ttlMs = 60_000) {
  const parsed = parseGateTimestamp(hostname);
  if (!parsed) return false;
  return isSubdomainLinkExpired(parsed.tsMs, ttlMs);
}

export function isNavLinkExpired(hostname, ttlMs = 60_000) {
  const parsed = parseNavTimestamp(hostname);
  if (!parsed) return false;
  return isSubdomainLinkExpired(parsed.tsMs, ttlMs);
}

/** @deprecated 使用 parseGateTimestamp / parseNavTimestamp */
export function parseLandingTimestamp(hostname) {
  return parseGateTimestamp(hostname) || parseNavTimestamp(hostname);
}

/** @deprecated 使用 isNavLinkExpired */
export function isLandingLinkExpired(hostname, ttlMs = 60_000) {
  return isNavLinkExpired(hostname, ttlMs);
}
